module.exports = __webpack_public_path__ + "static/img/Art.38f3997c.png";